
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, addDoc, deleteDoc, doc, onSnapshot, query, orderBy, updateDoc } from 'firebase/firestore';

const toYMD=(d)=>{ const dt=new Date(d); const y=dt.getFullYear(), m=String(dt.getMonth()+1).padStart(2,'0'), day=String(dt.getDate()).padStart(2,'0'); return `${y}-${m}-${day}`; };

function DayCard({dayDoc}){
  const [tasks,setTasks]=useState(dayDoc.tasks||[]);
  useEffect(()=>setTasks(dayDoc.tasks||[]),[dayDoc.id]);
  const addRow=()=>setTasks([...tasks,{text:'',done:false}]);
  const toggle=(i)=>{ const next=[...tasks]; next[i].done=!next[i].done; setTasks(next); };
  const save=async()=>{ await updateDoc(doc(db,'dailyTodos',dayDoc.id),{tasks}); };
  const remove=async()=>{ if(!window.confirm('Delete this day?'))return; await deleteDoc(doc(db,'dailyTodos',dayDoc.id)); };
  const setVal=(i,v)=>{ const next=[...tasks]; next[i].text=v; setTasks(next); };
  return(<div className='card'>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
      <h4 style={{margin:0}}>{dayDoc.day}</h4>
      <div>
        <button className='btn small primary' onClick={save}>Save</button>
        <button className='btn small' onClick={remove}>Delete Day</button>
      </div>
    </div>
    {tasks.map((t,i)=>(
      <div key={i} className={`todo-row ${t.done?'todo-done':''}`}>
        <input type='text' value={t.text} onChange={e=>setVal(i,e.target.value)} />
        <div><label className='checkbox'><input type='checkbox' checked={t.done} onChange={()=>toggle(i)} /><span>Done</span></label></div>
        <button className='btn tiny' onClick={()=>setTasks(tasks.filter((_,x)=>x!==i))}>🗑️</button>
      </div>
    ))}
    <button className='btn small' onClick={addRow}>Add Row</button>
  </div>);
}

export default function DailyTodos(){
  const [days,setDays]=useState([]);
  const [day,setDay]=useState(toYMD(new Date()));
  useEffect(()=>{
    const qy=query(collection(db,'dailyTodos'),orderBy('day','desc'));
    return onSnapshot(qy,snap=>setDays(snap.docs.map(d=>({id:d.id,...d.data()}))));
  },[]);
  const addDay=async()=>{
    await addDoc(collection(db,'dailyTodos'),{day,tasks:[],createdAt:new Date().toISOString()});
  };
  return(<div>
    <div className='card'>
      <h3>Daily To-Dos</h3>
      <div style={{display:'flex',gap:8,alignItems:'center'}}>
        <label>Day</label>
        <input type='date' value={day} onChange={e=>setDay(e.target.value)} />
        <button className='btn primary' onClick={addDay}>Add Day</button>
      </div>
    </div>
    <div style={{marginTop:12,display:'grid',gap:12}}>
      {days.map(d=>(<DayCard key={d.id} dayDoc={d} />))}
      {days.length===0 && <div className='card empty'>No days yet.</div>}
    </div>
  </div>);
}
